var Handlebars = require("/builds/product/cm/hyperchat-sdk/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "No messages longer than {max} chars";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./i18n/en_EN/err_message_too_long.hbs
// module id = 271
// module chunks = 0